const o = (t, e, n = 2) => {
  if (e === 0)
    return r(0);
  const c = t / e * 100;
  return r(parseFloat(c.toFixed(n)));
}, r = (t) => t;
export {
  o as getPercent,
  r as toPercent
};
